import type { IncidenceRules } from 'modules/bookkeepers/store/collections/incidenceRules'

const containsFieldInRules = (
  contractCues: { hasCues: boolean; incidenceRules: IncidenceRules },
  fieldName: string
) => {
  if (contractCues.hasCues) {
    return contractCues.incidenceRules.some((rule) => rule.attributes.field === fieldName)
  }
  return false
}

export default containsFieldInRules
